// extracted by mini-css-extract-plugin
export default {"dummmy":"pGYjZnRNJXwKWJHkN2Yz","root":"vHl2V6eHaUxBNwQlCReO","naked":"Lu5NoMsOA3EgickYBeK4","opaque":"LKccruvF26YUxJQFkzg1","outlined":"R46UwOER5aXPIY4Vo0wE"};